import React, { memo, ReactNode, useCallback } from 'react'
import { CircleX } from 'lucide-react'
import { THRESHOLD, INTERACTIVE } from '../styles'

export interface ThresholdField {
  key: string
  component: ReactNode
  className?: string
}

interface ThresholdRowProps {
  fields: ThresholdField[]
  onRemove?: () => void
  showRemove?: boolean
  className?: string
  separators?: ReactNode[]
}

// Static configuration to avoid recreation
const DEFAULT_ROW_CLASSES = "flex items-center gap-2 group" as const

export const ThresholdRow = memo<ThresholdRowProps>(function ThresholdRow({ 
  fields,
  onRemove,
  showRemove = false, // Default to false for better UX
  className = DEFAULT_ROW_CLASSES,
  separators = []
}) {
  const handleRemove = useCallback(() => {
    onRemove?.()
  }, [onRemove])

  return (
    <div className={className}>
      {fields.map((field, index) => (
        <React.Fragment key={field.key}>
          <div className={field.className}>
            {field.component}
          </div>
          {separators[index]}
        </React.Fragment>
      ))}
      
      {/* Always reserve space for remove button to maintain consistent layout */}
      <div className={THRESHOLD.layout.removeButtonSpace}>
        {showRemove && onRemove && (
          <button
            onClick={handleRemove}
            className={INTERACTIVE.removeButton}
            type="button"
            title="Remove row"
            aria-label="Remove this row"
          >
            <CircleX className={THRESHOLD.layout.separator} />
          </button>
        )}
      </div>
    </div>
  )
})